export default __webpack_public_path__ + "static/media/Listmodels.b68cbd42.svg";